import { useCallback, useEffect, useState } from 'react'
import { listMailboxes } from '../services/mailboxesApi'
import type { Mailbox, MailboxCapInfo } from '../types'

type State = {
  mailboxes: Mailbox[]
  cap: MailboxCapInfo
  loading: boolean
  error: string | null
}

const INITIAL_CAP: MailboxCapInfo = { maxSecondaries: 3, secondariesInUse: 0 }

export function useMailboxes(workspaceId: string | undefined) {
  const [state, setState] = useState<State>({
    mailboxes: [],
    cap: INITIAL_CAP,
    loading: !!workspaceId,
    error: null,
  })

  const refetch = useCallback(async () => {
    if (!workspaceId) return
    setState((s) => ({ ...s, loading: true, error: null }))
    try {
      const data = await listMailboxes(workspaceId)
      setState({ mailboxes: data.mailboxes, cap: data.cap, loading: false, error: null })
    } catch (err) {
      setState({
        mailboxes: [],
        cap: INITIAL_CAP,
        loading: false,
        error: err instanceof Error ? err.message : 'Could not load mailboxes',
      })
    }
  }, [workspaceId])

  useEffect(() => {
    void refetch()
  }, [refetch])

  return { ...state, refetch }
}
